import { Stack } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { LegislationLibraryFolderPathCrumb } from "./legislation-library-folder-path-crumb"

export function LegislationLibraryFolderPath({ item: path }) {
    return (
        <Stack
            direction="row"
            alignItems="center"
            spacing={0.5}
            sx={{ flexWrap: "wrap" }}
            data-cy="legislation-folder-path"
        >
            <Repeat list={path} item={<LegislationLibraryFolderPathCrumb />} />
        </Stack>
    )
}
